import Button, { ButtonVariant } from '@ben/orion/deprecated-button';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import styled, { css } from 'styled-components';

interface UnsavedChangesBarProps {
  isOpen: boolean;
  onReset: () => void;
  onSave: () => void;
}

const UnsavedChangesBar = ({
  isOpen,
  onReset,
  onSave,
}: UnsavedChangesBarProps) => {
  if (!isOpen) return;

  return (
    <Container>
      <Content>
        <Typography variant={TypographyVariant.bodyMd1}>
          You have unsaved changes
        </Typography>
        <ButtonContainer>
          <Button
            label="Reset"
            variant={ButtonVariant.secondary}
            onClick={onReset}
            width="120px"
          />
          <Button
            label="Save"
            onClick={onSave}
            variant={ButtonVariant.primary}
            width="120px"
          />
        </ButtonContainer>
      </Content>
    </Container>
  );
};

export default UnsavedChangesBar;

const Container = styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
`;

const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    color: ${theme.palette.neutral[100]};
    font-size: 14px;
    font-weight: 500;
    background: ${theme.palette.neutral['00']};
    border-radius: 50px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    min-width: 500px;
  `}
`;

const ButtonContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: ${theme.spacing(2)};
    margin-left: ${theme.spacing(3)};
  `}
`;
